import React, { useEffect } from "react";
import { Icon } from "@iconify/react";

const AppDownloadLayer = () => {

    const androidLink =
        "https://play.google.com/store/apps/details?id=com.w.media.wmediaapp";

    const iosLink =
        "https://apps.apple.com/us/app/w-media/id6760693305/";

    useEffect(() => {

        const userAgent =
            navigator.userAgent ||
            navigator.vendor ||
            window.opera;

        const isAndroid = /android/i.test(userAgent);

        const isIOS =
            /iPad|iPhone|iPod/.test(userAgent);

        const redirectTimer = setTimeout(() => {

            if (isAndroid) {

                window.location.href = androidLink;

            } else if (isIOS) {

                window.location.href = iosLink;
            }

        }, 2000);
        return () => clearTimeout(redirectTimer);
    }, []);

    return (
        <div
            style={{
                minHeight: "100vh",
                background:
                    "linear-gradient(135deg, #020617 0%, #0f172a 45%, #111827 100%)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "24px",
                overflow: "hidden",
                position: "relative"
            }}
        >
            <div
                style={{
                    position: "absolute",
                    width: "500px",
                    height: "500px",
                    borderRadius: "50%",
                    background: "#2563eb",
                    filter: "blur(180px)",
                    opacity: 0.2,
                    top: "-120px",
                    left: "-120px"
                }}
            />
            <div
                style={{
                    width: "100%",
                    maxWidth: "560px",
                    background: "rgba(255,255,255,0.08)",
                    border: "1px solid rgba(255,255,255,0.1)",
                    backdropFilter: "blur(14px)",
                    borderRadius: "32px",
                    padding: "42px 28px",
                    textAlign: "center",
                    position: "relative",
                    zIndex: 2,
                    boxShadow: "0 25px 80px rgba(0,0,0,0.4)"
                }}
            >
                <div
                    style={{
                        width: "110px",
                        height: "110px",
                        borderRadius: "28px",
                        background: "#ffffff",
                        margin: "0 auto 20px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}
                >
                    <img
                        src="/assets/images/logo.svg"
                        alt="logo"
                        style={{
                            width: "74px",
                            objectFit: "contain"
                        }}
                    />
                </div>
                <h5
                    style={{
                        color: "#fff",
                        fontSize: "42px",
                        fontWeight: "800",
                        marginBottom: "14px",
                        lineHeight: "35px"
                    }}
                >
                    Download
                    <br />
                    W Media App
                </h5>
                <p
                    style={{
                        color: "rgba(255,255,255,0.72)",
                        fontSize: "17px",
                        lineHeight: "30px",
                        marginBottom: "20px"
                    }}
                >
                    Scan QR code or click below buttons.
                    {/* <br />
                    Users automatically open the correct app store. */}
                </p>
                <div
                    style={{
                        background: "#ffffff",
                        padding: "5px",
                        borderRadius: "24px",
                        width: "fit-content",
                        margin: "0 auto 34px",
                        boxShadow:
                            "0 15px 45px rgba(255,255,255,0.08)"
                    }}
                >
                    <img
                        src="/assets/images/app-qr.png"
                        alt="App QR"
                        style={{
                            width: "210px",
                            height: "210px",
                            objectFit: "contain"
                        }}
                    />
                </div>
                <div
                    style={{
                        display: "flex",
                        gap: "14px",
                        width: "100%",
                        flexWrap: "wrap"
                    }}
                >
                    <a
                        href={androidLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                            flex: 1,
                            minWidth: "220px",
                            background: "#16a34a",
                            color: "#fff",
                            textDecoration: "none",
                            borderRadius: "18px",
                            padding: "18px 12px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "12px",
                            fontSize: "16px",
                            fontWeight: "700",
                            boxShadow:
                                "0 10px 35px rgba(22,163,74,0.35)"
                        }}
                    >
                        <Icon
                            icon="logos:google-play-icon"
                            width="26"
                        />
                        Android
                    </a>
                    <a
                        href={iosLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                            flex: 1,
                            minWidth: "220px",
                            background: "#000",
                            color: "#fff",
                            textDecoration: "none",
                            borderRadius: "18px",
                            padding: "18px 12px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "12px",
                            fontSize: "16px",
                            fontWeight: "700",
                            boxShadow:
                                "0 10px 35px rgba(0,0,0,0.4)"
                        }}
                    >
                        <Icon
                            icon="logos:apple-app-store"
                            width="26"
                        />
                        iPhone
                    </a>
                </div>
                {/* Footer */}
                {/* <div
                    style={{
                        marginTop: "28px",
                        color: "rgba(255,255,255,0.5)",
                        fontSize: "14px"
                    }}
                >
                    Redirecting automatically based on device...
                </div> */}
            </div>
        </div>

    );
};

export default AppDownloadLayer;